import { render, staticRenderFns } from "./startImage.vue?vue&type=template&id=df4d3036&scoped=true"
import script from "./startImage.vue?vue&type=script&lang=js"
export * from "./startImage.vue?vue&type=script&lang=js"
import style0 from "./startImage.vue?vue&type=style&index=0&id=df4d3036&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df4d3036",
  null
  
)

export default component.exports